import { Extension } from '@tiptap/core';

export const CustomKeyMap = Extension.create({
  name: 'customKeyMap',

  addOptions() {
    return {
      customEnterFunction: () => {},
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { view } = editor;
        const editorHTML = view?.dom?.innerHTML;
        const tempDiv = document?.createElement('div');
        tempDiv.innerHTML = editorHTML;
        const pTag = tempDiv?.querySelector('p');
        const lastChild = pTag.lastElementChild;

        // Skip Enter for suggestion, when they are mentioning users
        if (
          lastChild &&
          lastChild?.classList?.length &&
          lastChild?.classList?.contains('suggestion')
        ) {
          return false;
        }
        this.options.customEnterFunction();
        return true;
      },
      'Shift-Enter': () => {
        this.editor.commands.setHardBreak();
        return true;
      },
    };
  },
});
